import React from 'react';
import { createContainer } from 'react-tracked';
import { getTheme } from '../theme';

const useValueTheme = () => React.useState(getTheme(JSON.parse(localStorage.getItem("darkMode")) || false));

export const { Provider: ThemeState, useTracked: useTrackedTheme } = createContainer(useValueTheme, { concurrentMode: true });

const useValueDarkMode = () => React.useState(JSON.parse(localStorage.getItem("darkMode")) || false);

export const { Provider: DarkModeState, useTracked: useTrackedDarkMode } = createContainer(useValueDarkMode, { concurrentMode: true });

const useValueUser = () => React.useState({});

export const { Provider: UserState, useTracked: useTrackedUser } = createContainer(useValueUser, { concurrentMode: true });

const useValueOpenServiceOrderWorkHistory = () => React.useState(undefined);

export const { Provider: UserOpenServiceOrderWorkHistoryState, useTracked: useTrackedUserOpenServiceOrderWorkHistory } = createContainer(useValueOpenServiceOrderWorkHistory, { concurrentMode: true });

const useValueNotificationsUnread = () => React.useState(0);

export const { Provider: NotificationsUnreadState, useTracked: useTrackedNotificationsUnread } = createContainer(useValueNotificationsUnread, { concurrentMode: true });

const useValueLocation = () => React.useState(undefined);

export const { Provider: LocationState, useTracked: useTrackedLocation } = createContainer(useValueLocation, { concurrentMode: true });

const useValueServiceInputInMinutes = () => React.useState(JSON.parse(localStorage.getItem("QuoteInMinutes")) || false);

export const { Provider: ServiceInputInMinutesState, useTracked: useTrackedServiceInputInMinutes } = createContainer(useValueServiceInputInMinutes, { concurrentMode: true });